import { render } from "./Frozen.vue?vue&type=template&id=ec61c0e2&scoped=true"
import script from "./Frozen.vue?vue&type=script&lang=js"
export * from "./Frozen.vue?vue&type=script&lang=js"

import "./Frozen.vue?vue&type=style&index=0&id=ec61c0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec61c0e2"]])

export default __exports__